'use client';

import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useEffect } from 'react';

export default function CustomAnalyticsContext() {
  const { setContext } = useAnalytics();

  useEffect(() => {
    const location = window.location.pathname;
    const query = location.split('/').at(-1);
    setContext('add_to_cart_page', {
      item_id: Number(query)
    });
  }, [setContext]);

  return null;
}
